/**
 * @generated SignedSource<<f0c59f035e8c22892da1c30773465a6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationCaptcha_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayCaptcha",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hcaptchaSiteKey",
      "storageKey": null
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "1a43277eb60ed3312bf2fa9945257006";

module.exports = node;
